import React, {useEffect, useState} from 'react';

import {ErrorBoundary} from '@sentry/react';

import {CellEditable} from '@pb/kit-component-table-interactions';

import type {InteractiveColumn} from './typedef';

const checkElementInContainer = (dataTableId: string, rowIndex: number, columnIndex: number) => {
    const container = document.getElementById(`${dataTableId}-row-${rowIndex}-cell-${columnIndex}`);
    const element = document.documentElement;

    if (container && element) {
        return container.getBoundingClientRect().right < element.clientWidth;
    }

    return false;
};


type CellInteractionsLayerProps = {
    children: React.ReactElement,
    dataTableId: string,
    column: InteractiveColumn,
    columnIndex: number,
    rowIndex: number,
};

export const InteractiveCell = (props: CellInteractionsLayerProps) => {
    const {
        dataTableId,
        columnIndex,
        rowIndex,
        column,
        children,
    } = props;

    const [isEditMode, setIsEditMode] = useState<boolean>(false);
    const isEditable = !!column.columnType;

    useEffect(() => {
        const isFirstCell = rowIndex === 0;
        const isIntoContainer = checkElementInContainer(dataTableId, rowIndex, columnIndex);

        setIsEditMode(isEditable && isFirstCell && isIntoContainer);
    }, [columnIndex, dataTableId, isEditable, rowIndex]);

    if (column.columnType && !column.fixed) {
        return (
            <ErrorBoundary>
                <CellEditable {...{
                    isEditable,
                    isEditMode,
                    columnIndex,
                    columnId: column.columnId,
                    rowIndex,
                }}
                />
            </ErrorBoundary>
        );
    } else {
        return children;
    }
};
